import styled from "styled-components";

export const MainDiv=styled.div`
    width: 100%;
`

export const Table = styled.table`
    width: 100%;    
    //table-layout: fixed;
    border-collapse: collapse;

    background: white;
    border: 1px solid #e2e8e5;
    border-radius: 10px;

    font-family: "Segoe UI", sans-serif;
    font-size: 11px;
`;

export const Thead = styled.thead`
    background: #eaf6ee;
`;

export const Th = styled.th`
    padding: 8px 4px;
    background: #eaf6ee;
    color: #17683a;

    border: 1px solid #dce8df;

    font-size: 11px;
    font-weight: 600;
    text-align: center;

    overflow-wrap: anywhere;
    white-space: normal;
`;
export const Tr = styled.tr`
    font-size: 11px;
    color: #374151;
    background: #ffffff;

    transition: background-color 0.2s ease;

    &:nth-child(even) {
        background: #f8fbf9;
    }

    &:hover {
        background: #eaf8ef;
    }

    td {
        vertical-align: middle;
    }
`;
export const Td = styled.td`
    padding: 7px 4px;
    border: 1px solid #edf0ee;

    text-align: center;
    vertical-align: middle;
    font-size: 11px;

    overflow-wrap: anywhere;
    white-space: normal;
`;

export const TdGradient = styled(Td)`
    cursor: pointer;
    font-weight: 600;

    background: ${({ $value = 0 }) => {
        const p = Math.min(
                100,
                Math.max(0, Number($value) || 0)
        );

        const color =
                p >= 90 ? "#bbf7d0" :
                        p >= 60 ? "#fef08a" :
                                "#fecaca";

        return `linear-gradient(
            to right,
            ${color} ${p}%,
            #f8fafc ${p}%
        )`;
    }};

    &:hover {
        filter: brightness(0.95);
    }
`;
